import { useEffect } from 'react';

// Visibility tracker manages loading indicator suppression during tab switches
export function VisibilityTracker() {
  useEffect(() => {
    // Keep track of the timeout to prevent memory leaks
    let loaderResetTimeout: number | undefined;

    const handleVisibilityChange = () => {
      // Only need to take action when tab becomes visible
      if (document.visibilityState === 'visible') {
        // Suppress loading indicators for a brief period after tab visibility changes
        window.showLoadingIndicators = false;

        // Clear any existing timeouts to prevent race conditions
        if (loaderResetTimeout) window.clearTimeout(loaderResetTimeout);

        // Set a new timeout to re-enable loading indicators
        loaderResetTimeout = window.setTimeout(() => {
          window.showLoadingIndicators = true;
        }, 800); // Slightly shorter timeout is sufficient
      }
    };

    // Initialize the flag to true
    window.showLoadingIndicators = true;

    // Register visibility change listener
    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Cleanup on component unmount
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      if (loaderResetTimeout) window.clearTimeout(loaderResetTimeout);
    };
  }, []);

  return null;
}

export default VisibilityTracker;
